// ReplyCell.jsx
import React, { useState } from 'react';
import { getDateWithTimeFormat } from '../utility-files/date-util/DateHandling';
import ExpandableCell from './ExpandableCell ';
import RichTextView from './RichTextView';

const ReplyCell = ({ message, replies, data }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const safeReplies = Array.isArray(replies) ? replies : [];

  if (safeReplies.length === 0) {
    return <span>No reply</span>;
  }

  return (
    <>
      {safeReplies.length > 1 && (
        <button
          className="viewAllMsg"
          onClick={() => setModalOpen(true)}
          style={{
            marginBottom: '8px',
            cursor: 'pointer',
            color: '#007bff',
            background: 'none',
            border: 'none',
          }}
        >
          View All
        </button>
      )}

      <div className="repltCell-wrap">
        {/* {safeReplies.slice(0, 1).map(reply => (
          <div key={reply.id} className="SenderReplySection">
            <div className="SenderReplySectionIn">
              <span>
                <ExpandableCell text={reply.reply} truncateLength={30} />
              </span>
            </div>
          </div>
        ))} */}
        <RichTextView value={safeReplies[0]?.reply} maxLength={60} />
      </div>

      {modalOpen && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          onClick={() => setModalOpen(false)}
          style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg MsgReply_tbl"
            role="document"
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-content modal-lg">
              <div className="modal-header">
                <h5 className="modal-title">Message and Reply</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setModalOpen(false)}
                ></button>
              </div>

              <div className="data-details-in-card leadaction-card">
                <div className="d-flex leadaction-in">
                  {data?.itemname && (
                    <p>
                      <strong>Item:</strong> <span>{data.itemname}</span>
                    </p>
                  )}
                  {data?.tokenid && (
                    <p>
                      <strong>Token Id:</strong> <span>{data.tokenid}</span>
                    </p>
                  )}
                </div>
                {data?.shortDescription && (
                  <p>
                    <strong>Short Description:</strong>{' '}
                    <RichTextView value={data.shortDescription} maxLength={140} />
                  </p>
                )}
              </div>

              <div className="plans-modal-table" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <div className="innerMsgSection">
                  <strong>Message:</strong>
                  <div className="MessageExpand">
                    <RichTextView value={message} maxLength={125} />
                  </div>
                </div>
              </div>

              <div className="plans-modal-table">
                <div className="innerMsgSection innerMsgSectionScroll">
                  <strong>Reply:</strong>
                  {safeReplies.length > 0 ? (
                    safeReplies.map(reply => (
                      <div className="innerReplySection" key={reply.id}>
                        <RichTextView value={reply.reply} maxLength={80} />{' '}
                        <label>{getDateWithTimeFormat(reply.createdAt)}</label>
                      </div>
                    ))
                  ) : (
                    <p>No reply.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReplyCell;
